import React, { useRef } from 'react';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
import toast from 'react-hot-toast';
import useEasyUploadLinkModalContext from '../context/useEasyUploadLinkModalContext';
function Form() {
    const namespace = 'features.modals.easy_upload_link_modal';
    const inputRef = useRef(null);
    const { easyUploadLink, updateEasyUploadLink, easyUploadLinkUpdateReady } = useEasyUploadLinkModalContext();
    const copyEasyUploadLink = () => {
        if (!inputRef.current)
            return;
        inputRef.current.select();
        navigator.clipboard
            .writeText(inputRef.current.value)
            .then(() => {
            toast.success(translate('copied', { namespace }));
        })
            .catch(() => {
            toast.error(translate('failed_to_copy', { namespace }));
        });
    };
    const onUpdateEasyUploadLink = () => {
        updateEasyUploadLink()
            .then(() => {
            toast.success(translate('refreshed', { namespace }));
        })
            .catch(() => {
            toast.error(translate('failed_to_refresh', { namespace }));
        });
    };
    return (React.createElement("div", { className: "easyUploadLinkRow" },
        React.createElement("div", { className: "qmb-input--blank" },
            React.createElement("input", { name: "easyUploadLink", ref: inputRef, value: easyUploadLink !== null && easyUploadLink !== void 0 ? easyUploadLink : '', className: "form-control easyUploadLinkField", readOnly: true })),
        React.createElement(Button, { variant: "secondary", onClick: onUpdateEasyUploadLink, disabled: !easyUploadLinkUpdateReady, "aria-label": translate('refresh', { namespace: 'features.commons' }) },
            React.createElement("i", { className: "fa-light fa-arrow-rotate-right" })),
        React.createElement(Button, { variant: "primary", onClick: copyEasyUploadLink }, translate('copy', { namespace: 'features.commons' }))));
}
export default Form;
